var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 44,
    height: 44,
    transform: "translate(0 0)",
    fill: "#de1a28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10513",
    "data-name": "Group 10513",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27728",
    "data-name": "Path 27728",
    d: "M33.733,44a4.637,4.637,0,0,1-4.4-4.4V38.133H14.667V39.6a4.407,4.407,0,0,1-4.4,4.4,4.637,4.637,0,0,1-4.4-4.4V38.133H4.4a4.255,4.255,0,0,1-4.4-4.4V22a4.407,4.407,0,0,1,3.426-4.29l1.881-11.5A7.464,7.464,0,0,1,12.621,0H31.089A7.455,7.455,0,0,1,38.4,6.16l1.881,11.5A4.679,4.679,0,0,1,44,22V33.733a4.255,4.255,0,0,1-4.4,4.4H38.133V39.6a4.407,4.407,0,0,1-4.4,4.4M13.2,35.2H30.8a1.467,1.467,0,0,1,1.467,1.467V39.6a1.718,1.718,0,0,0,1.467,1.467A1.47,1.47,0,0,0,35.2,39.6V36.667A1.467,1.467,0,0,1,36.667,35.2H39.6a1.322,1.322,0,0,0,1.467-1.467V22A1.718,1.718,0,0,0,39.6,20.533h-.579a1.47,1.47,0,0,1-1.451-1.228L35.509,6.68a4.478,4.478,0,0,0-4.42-3.747H12.621a4.494,4.494,0,0,0-4.427,3.8L6.137,19.305a1.463,1.463,0,0,1-1.447,1.228A1.561,1.561,0,0,0,2.933,22V33.733A1.322,1.322,0,0,0,4.4,35.2H7.333A1.467,1.467,0,0,1,8.8,36.667V39.6a1.718,1.718,0,0,0,1.467,1.467A1.472,1.472,0,0,0,11.733,39.6V36.667A1.467,1.467,0,0,1,13.2,35.2m20.533-2.933a4.255,4.255,0,0,1-4.4-4.4,4.4,4.4,0,1,1,8.8,0,4.407,4.407,0,0,1-4.4,4.4m0-5.867a1.322,1.322,0,0,0-1.467,1.467,1.322,1.322,0,0,0,1.467,1.467A1.47,1.47,0,0,0,35.2,27.867,1.322,1.322,0,0,0,33.733,26.4M10.267,32.267a4.255,4.255,0,0,1-4.4-4.4,4.255,4.255,0,0,1,4.4-4.4,4.255,4.255,0,0,1,4.4,4.4,4.407,4.407,0,0,1-4.4,4.4m0-5.867A1.322,1.322,0,0,0,8.8,27.867a1.322,1.322,0,0,0,1.467,1.467,1.472,1.472,0,0,0,1.467-1.467A1.322,1.322,0,0,0,10.267,26.4m22.888-5.867h-22.6a1.467,1.467,0,0,1-1.443-1.721L11.178,7.079a1.465,1.465,0,0,1,1.443-1.212H31.089a1.465,1.465,0,0,1,1.443,1.212L34.6,18.812a1.467,1.467,0,0,1-1.443,1.721M12.3,17.6h19.1L29.861,8.8H13.853Z",
    transform: "translate(0 0)",
    fill: "#de1a28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterCarIcon);
export default __webpack_public_path__ + "static/media/enter_car_icon.b423dff29673566d0f16c9815315f79a.svg";
export { ForwardRef as ReactComponent };